import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { getProtectedRoute } from 'helpers/routeHelper';
import { DashContainer, ScrollContainer, MenuOverlay, toastProgressStyles } from './styles';
import ToastItem from 'molecules/ToastItem';
import Header from 'organisms/Header';
import Sidebar from 'organisms/Sidebar';
import NotifListCard from 'organisms/NotifListCard';
import getRoutes from './routes';
import firebaseApp from '../../firebase';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllNotifs } from 'Redux/actions/NotifActions';
import { getMyDetailsData, reset } from 'Redux/actions/LoginActions';
import { USER_SELF } from 'fixtures/api';
import { putData } from 'services/cmsService';
import { logout } from 'services/authService';
import { removeCredentialsLocal } from 'utils/localData/credentials';
import { withMsal } from "@azure/msal-react";
import lo from 'lodash'

const messaging = firebaseApp.messaging();

export class DashboardLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowNotif: false,
      isShowMenu: true,
      routes: []
    }
    this.switchNotif = this.switchNotif.bind(this)
    this.switchMenu = this.switchMenu.bind(this)
  }

  componentDidMount() {
    const { viewState: { isMobileView } } = this.props
    if (isMobileView) {
      this.setState({ isShowMenu: false })
    }

    this.firebaseInit();
    this.props.getMyDetailsData()
    this.props.getAllNotifs();
  }

  componentDidUpdate(prevProps) {
    const { viewState: { isMobileView }, userLogin, site } = this.props

    if (prevProps.viewState.isMobileView !== isMobileView) {
      this.setState({ isShowMenu: !isMobileView })
    }

    if (userLogin && userLogin.userDetail && !prevProps.userLogin.userDetail) {
      this.setState({ routes: getRoutes(userLogin.userDetail.permissions) })
    }

    if (prevProps.site !== site && lo.isUndefined(site)) {
      alert('Your company is not registered in hris. Please contact the Administrator !')
    }

  }

  // method for logging out
  async _logout() {
    const { instance } = this.props.msalContext;
    const accounts = instance.getAllAccounts();

    const { reset } = this.props
    let logoutStatus = await logout()
    if (logoutStatus) {
      removeCredentialsLocal()
      reset()
      
      // handle logout from azure account
      if (!lo.isEmpty(accounts)) {
        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: `${process.env.AZURE_AD_REDIRECT_URI}`
        });
      }
    }
  }

  // method for toggling show Notification card
  switchNotif() {
    const { isShowNotif } = this.state
    this.setState({ isShowNotif: !isShowNotif })
  }

  // method for toggling show sidebar menu (mobile only)
  switchMenu() {
    const { isShowMenu } = this.state
    this.setState({ isShowMenu: !isShowMenu })
  }

  // method for navigating to Notification List page route
  seeMoreNotif() {
    const { history: { push } } = this.props
    this.switchNotif()
    push('/dash/notifications')
  }

  // method for handling Firebase messages
  handleFirebaseMessage(payload) {
    const { notification, data } = payload;
    toast(<ToastItem notification={notification} data={data} />, {
      autoClose: 8000,
      draggable: false
    });
    this.props.getAllNotifs();
  }

  // method for initializing the Firebase
  firebaseInit() {
    messaging.onMessage(this.handleFirebaseMessage.bind(this));
    messaging
      .requestPermission()
      .then(() => {
        // Notification permission granted
        messaging
          .getToken()
          .then(fcmToken => {
            /*
              Send to server
              Endpoint: http://{serverURL}/users
              payload: {id, fcmToken: token}
            */
            putData(USER_SELF, { fcmToken })
          })
          .catch(console.error);
      })
      .catch(console.error);
  }

  render() {
    const { notifications, viewState: { isMobileView }, theme } = this.props
    const { isShowNotif, isShowMenu, routes } = this.state
    return (
      <div className={'row col-12 mx-0 px-0'}>
        <Sidebar isMobile={isMobileView} isShown={isShowMenu} fnSwitch={this.switchMenu} />
        <DashContainer isMobile={isMobileView}>
          {isMobileView && isShowMenu &&
            <MenuOverlay onClick={this.switchMenu} />
          }
          <Header
            fnShowNotif={this.switchNotif}
            fnShowMenu={this.switchMenu}
            fnLogout={this._logout.bind(this)}
            {...this.props}
          />
          <NotifListCard
            datas={notifications}
            isShow={isShowNotif}
            fnRoute={this.seeMoreNotif.bind(this)}
            fnSwitch={this.switchNotif}
          />
          <ScrollContainer>
            {routes.map((r, i) => (
              <Route
                key={i}
                path={`${this.props.match.url}${r.path}`}
                exact={r.exact}
                render={props => getProtectedRoute(r, props)}
              />
            ))}
          </ScrollContainer>
        </DashContainer>
        <ToastContainer progressStyle={toastProgressStyles(theme)} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userLogin: state.userLogin,
    notifications: state.notifications,
    viewState: state.viewState,
    site: state.globals.site
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllNotifs,
      getMyDetailsData,
      reset
    },
    dispatch
  )

export default withMsal(withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DashboardLayout)
  )
));
